import { render, staticRenderFns } from "./MyReferrals.vue?vue&type=template&id=64cf55de&scoped=true"
import script from "./MyReferrals.vue?vue&type=script&lang=js"
export * from "./MyReferrals.vue?vue&type=script&lang=js"
import style0 from "./MyReferrals.vue?vue&type=style&index=0&id=64cf55de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf55de",
  null
  
)

export default component.exports